import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import icon from '@tencent/docs-design-resources/pc/png@3x/download_mobile@3x.png';

export const config = {
    id: ActionType.MOBILE_REMOTE_PLAY,
    icon,
    content: i18n.t('手机遥控提词'),
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        style: {
        },
        tooltip: config.content,
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        icon: <img src={config.icon} alt={''}/>,
    },
];
